import React from "react";
import "./styles.scss";
import FacebookIcon from "../../svgs/FacebookIcon";

const Services = () => (
    <div className="services">
        <div className="inner services__inner">
            <h1 className="services__title">
                We offer management, advisory, and research services to
                institutional investors
            </h1>
            <div className="services__content">
                <div className="services__section">
                    <h2 className="services__heading">
                        <img
                            src="../../../../images/home/service-research.svg"
                            alt="Research"
                        />
                        Research
                    </h2>
                    <p className="services__text">
                        Which lending platforms are achieving their targeted
                        returns and which aren't? Where are the best investment
                        opportunities in the European direct lending market?
                        Orca helps investors navigate through the complexity,
                        helping to reduce risk and increase returns over the
                        long term. We work to an agreed investment mandate to
                        deliver consistent, predictable returns.{" "}
                    </p>
                </div>
                <div className="services__section">
                    <h2 className="services__heading">
                        <img
                            src="../../../../images/home/service-cash.svg"
                            alt="Cash Deployment"
                        />
                        Cash Deployment
                    </h2>
                    <p className="services__text">
                        Investment structures vary between lenders and
                        investment capital needs to match origination. As a
                        portfolio manager or sub-advisor, Orca takes care of the
                        difficult task of building and managing diversified
                        portfolios across lenders.
                    </p>
                </div>
                <div className="services__section">
                    <h2 className="services__heading">
                        <img
                            src="../../../../images/home/service-risk.svg"
                            alt="Risk Management"
                        />
                        Risk Management
                    </h2>
                    <p className="services__text">
                        The early stage of the peer to peer lending market makes
                        it difficult to assess credit risk. Lenders typically
                        operate in niche sub-sectors with separate risk
                        profiles. Orca carries out risk management services to
                        help ensure risks are identified, measured and
                        mitigated. This ensures expected returns are realised.
                    </p>
                </div>
                <div className="services__section">
                    <h2 className="services__heading">
                        <img
                            src="../../../../images/home/service-reporting.svg"
                            alt="Reporting"
                        />
                        Reporting
                    </h2>
                    <p className="services__text">
                        Monitoring investments is challenging as the data
                        delivered by the lenders is not standardised. Orca pulls
                        all of this data together so performance data is
                        consistent and comparable across lenders.
                    </p>
                </div>
            </div>
        </div>
    </div>
);

export default Services;
